import {Icons} from '@pb/kit-component-icon';
import {Status} from '@pb/kit-component-push-notification';

import {DOMAIN_URL_FORBIDDEN_SYMBOL, DOMAIN_URL_FORBIDDEN_SYMBOL_MESSAGE} from './constants';

import type {
    OnCloseNote,
    OnCreateNote,
} from '@pb/kit-component-push-notification';


type NoteIdRef = {current: string | null};

type PushNotificationHandlers = {
    onCreateNote: OnCreateNote,
    onCloseNote: OnCloseNote,
};

export const DOMAIN_WARNING_NOTE_ID = 'sso-domain-url-warning';
export const DOMAIN_WARNING_AUTO_HIDE_TIMEOUT = 3000;

type ShowDomainForbiddenNoteParams = PushNotificationHandlers & {
    noteIdRef: NoteIdRef,
    autoHideTimeout?: number,
};

export const showDomainForbiddenNote = ({
    noteIdRef,
    onCreateNote,
    onCloseNote,
    autoHideTimeout = DOMAIN_WARNING_AUTO_HIDE_TIMEOUT,
}: ShowDomainForbiddenNoteParams) => {
    if (noteIdRef.current) {
        return;
    }

    noteIdRef.current = DOMAIN_WARNING_NOTE_ID;
    onCreateNote({
        id: DOMAIN_WARNING_NOTE_ID,
        status: Status.WARNING,
        buttonProps: {
            iconProps: {type: Icons.CLOSE},
            onClick: () => {
                onCloseNote(DOMAIN_WARNING_NOTE_ID);
                noteIdRef.current = null;
            },
        },
        body: () => DOMAIN_URL_FORBIDDEN_SYMBOL_MESSAGE,
        autoHideTimeout,
    });
};

export const sanitizeDomainValue = (domain: string) => {
    if (!domain || !domain.includes(DOMAIN_URL_FORBIDDEN_SYMBOL)) {
        return domain;
    }

    return domain.split(DOMAIN_URL_FORBIDDEN_SYMBOL).join('');
};

type CloseDomainForbiddenNoteParams = {
    noteIdRef: NoteIdRef,
    onCloseNote: PushNotificationHandlers['onCloseNote'],
};

export const closeDomainForbiddenNote = ({
    noteIdRef,
    onCloseNote,
}: CloseDomainForbiddenNoteParams) => {
    if (!noteIdRef.current) {
        return;
    }

    onCloseNote(noteIdRef.current);
    noteIdRef.current = null;
};
